import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import CommonField from 'common/components/entities/Field/FieldUi'
import { FieldInterface } from 'common/types/entities/field-interface'
import { BorderStyleEnum, PaddingType } from 'common/types/styleTypes'
import React from 'react'
import { useFormField } from 'src/editor/shared/hooks/use-form-fields'
import { EntityProps } from '../../../types'
import { useContactUsDescendantIds } from './ContactUs'

function ContactUsField({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<FieldInterface>) {
  const entityIds = useContactUsDescendantIds()

  const {
    calculatedBorder,
    calculatedPadding,
    calculatedFontSize,
    calculatedLineHeight,
    calculatedTextAlign,
    // calculatedLetterSpacing,
    // calculatedFontFamily,
  } = useFormField({
    border: entity.border,
    mobileBorder: entity.mobileBorder,
    padding: entity.padding,
    mobilePadding: entity.mobilePadding,
    fontSize: entity.fontSize,
    mobileFontSize: entity.mobileFontSize,
    lineHeight: entity.lineHeight,
    mobileLineHeight: entity.mobileLineHeight,
    // fontFamily: fontFamily,
    // mobileFontFamily: fontFamily,
    textAlign: entity.textAlign,
    mobileTextAlign: entity.mobileTextAlign,
  })

  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
      isRemoveAllowed={false}
      isSaveAllowed={false}
      isCopyAllowed={false}
      dropBoxAllowedEntityIds={entityIds}
    >
      <CommonField
        placeholder={entity.placeholder}
        padding={calculatedPadding.desktop}
        lineHeight={calculatedLineHeight.desktop}
        mobileLineHeight={calculatedLineHeight.mobile}
        textAlign={calculatedTextAlign.desktop}
        mobileTextAlign={calculatedTextAlign.mobile}
        mobilePadding={calculatedPadding.mobile}
        id={entity.htmlAttrId}
        border={calculatedBorder.desktop}
        mobileBorder={calculatedBorder.mobile}
        backgroundColor={entity.backgroundColor}
        mobileBackgroundColor={entity.mobileBackgroundColor}
        color={entity.color}
        mobileColor={entity.mobileColor}
        fontSize={calculatedFontSize.desktop}
        mobileFontSize={calculatedFontSize.mobile}
        boxShadow={entity.boxShadow}
        mobileBoxShadow={entity.mobileBoxShadow}
      />
    </BaseEntityNew>
  )
}

export default ContactUsField
